// src/pages/Contact.jsx
import React, { useState } from "react";
import { MapPin, Mail, Phone, MessageCircle } from "lucide-react";
import { toast } from 'react-toastify';


import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase1"; // your initialized Firestore
import { Helmet } from "react-helmet-async";

const Contact = () => {

     const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.placeholder.toLowerCase().replace(" ", "")]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "FITContactMessages"), {
        ...formData,
        createdAt: serverTimestamp(),
      });

      toast.success("Message sent successfully! 📩");

      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message: ", error);
      toast.error("Failed to send message ❌");
    }
  };


    return (
      <>
      <Helmet>

  <title>
    Contact Focus Inspection Technology | NDT Inspection Company | Get Quote PAUT TOFD UT RT MT PT
  </title>

  <meta
    name="description"
    content="
Contact Focus Inspection Technology for PAUT, TOFD, UT, RT, MT, PT, welding inspection, pipeline inspection and industrial NDT services. Get quote for inspection projects worldwide.
"
  />

  <meta
    name="keywords"
    content="
Focus Inspection Technology contact,
contact focus ndt,
ndt company contact,
inspection company india,
paut tofd contact,
industrial inspection contact,
welding inspection company,
pipeline inspection services,
ndt services india,
focus inspection phone
"
  />

  <link
    rel="canonical"
    href="https://focusinspectiontechnology.com/contact"
  />

  <meta
    property="og:title"
    content="Contact Focus Inspection Technology | NDT Inspection"
  />

  <meta
    property="og:description"
    content="Contact Focus Inspection Technology for advanced NDT inspection services worldwide."
  />

  <meta
    property="og:image"
    content="https://focusinspectiontechnology.com/images/integrity.jpg"
  />

  <meta
    property="og:url"
    content="https://focusinspectiontechnology.com/contact"
  />

  <meta property="og:type" content="website" />

  <meta name="twitter:card" content="summary_large_image" />

  <meta
    name="twitter:title"
    content="Contact Focus Inspection Technology"
  />

  <meta
    name="twitter:description"
    content="Get in touch for PAUT TOFD UT RT MT PT inspection services."
  />

  <meta
    name="twitter:image"
    content="https://focusinspectiontechnology.com/images/integrity.jpg"
  />

</Helmet>
        <div className="w-full bg-gray-50">
            {/* Hero Section */}
            <section className="relative w-full h-80 flex items-center justify-center mb-16 overflow-hidden">
                {/* Gradient Background */}
                <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-blue-800"></div>

                {/* Industrial Pattern Overlay */}
                <svg className="absolute inset-0 w-full h-full opacity-20" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="hexPattern" width="60" height="52" patternUnits="userSpaceOnUse" patternTransform="rotate(30)">
                            <polygon points="30,0 60,15 60,45 30,60 0,45 0,15" stroke="white" strokeWidth="0.3" fill="none" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#hexPattern)" />
                    <circle cx="150" cy="100" r="80" stroke="white" strokeWidth="0.5" fill="none" />
                    <circle cx="600" cy="50" r="120" stroke="white" strokeWidth="0.5" fill="none" />
                </svg>

                <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg">
                        Contact Us
                    </h1>
                    <p className="text-lg md:text-xl max-w-2xl mx-auto text-white">
                        Reach out to FOCUS Inspection Technology for NDT services, inquiries, or support.
                    </p>
                </div>
            </section>

            {/* Contact Info + Form */}

<section className="max-w-7xl mx-auto px-6 lg:px-8 pb-20 grid md:grid-cols-2 gap-12">
  {/* Contact Info */}
  <div className="space-y-8">
    <h2 className="text-3xl font-bold text-gray-900">Get in Touch</h2>
    <p className="text-gray-700 text-lg leading-relaxed">
      We are always ready to discuss your NDT inspection requirements. Contact us via email, phone, WhatsApp, or visit our office.
    </p>
    <div className="space-y-4">
      <div className="flex items-center space-x-3">
        <MapPin className="text-blue-700" />
        <span className="text-gray-700">
          407, Laaman Industrial Park, Plot No. C-9, Road No.12, MIDC, Wagle Industrial Estate, Thane West, Maharashtra 400604
        </span>
      </div>

      <div className="flex items-center space-x-3">
        <Mail className="text-blue-700" />
        <a
          href="mailto:focusinspectiontechnology@gmail.com"
          className="text-gray-700 hover:text-blue-700 transition"
        >
          focusinspectiontechnology@gmail.com
        </a>
      </div>

      <div className="flex items-center space-x-3">
        <Phone className="text-blue-700" />
        <a
          href="tel:+919833205915"
          className="text-gray-700 hover:text-blue-700 transition"
        >
          +91 98332 05915
        </a>
      </div>

      <div className="flex items-center space-x-3">
        <MessageCircle className="text-green-500" />
        <a
          href="https://wa.me/919833205915"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-700 hover:text-green-500 transition"
        >
          Chat on WhatsApp
        </a>
      </div>
    </div>
  </div>

  {/* Contact Form */}
   <div className="bg-gray-900 p-10 rounded-2xl shadow-lg text-white">
      <h3 className="text-2xl font-semibold mb-6">Send a Message</h3>
      <form className="space-y-4" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
        />
        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
        />
        <textarea
          placeholder="Your Message"
          rows="5"
          value={formData.message}
          onChange={(e) =>
            setFormData({ ...formData, message: e.target.value })
          }
          className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
        />
        <button
          type="submit"
          className="bg-blue-700 hover:bg-blue-800 transition px-6 py-3 rounded-lg font-semibold"
        >
          Send Message
        </button>
      </form>
    </div>


</section>


            {/* Google Map */}
            <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-20">
                <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Our Location</h2>
                <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg">
                    <iframe
                        title="FOCUS Inspection Technology Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.0142910490435!2d72.95454947466801!3d19.194578148240335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b9e03e0add25%3A0xb06e685fe3a80cf1!2sLaaman%20Industrial%20Park!5e0!3m2!1sen!2sin!4v1755757281446!5m2!1sen!2sin"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>

                </div>
            </section>
        </div>
        </>
    );
};

export default Contact;
